import { FavouriteResponse, FetchCtnByRuleResponse } from '../../api/data-contracts';
import { CtnPhoneCategory } from './types';

export const mapCtnListToPhoneNumbersList = ({
  numbers,
}: FetchCtnByRuleResponse | FavouriteResponse): Array<CtnPhoneCategory> =>
  numbers?.map((category) => ({
    title: undefined,
    id: category.alias,
    price: category.price,
    niceClass: category.category,
    numbers:
      category.numbers?.map((number, i) => ({
        id: (number.value || '') + number.price + category.alias + i,
        number: `+7${number.value}`,
        formattedNumber: number.formattedValue,
        price: number.price,
        oldPrice: number.oldPrice && number.oldPrice !== number.price ? number.oldPrice : null,
        category: category.alias,
        rawNumber: number.value,
        niceClass: category.category,
      })) || [],
  })) || [];
